import { render, staticRenderFns } from "./MenuItemCollapse.vue?vue&type=template&id=55bd5a60&scoped=true"
import script from "./MenuItemCollapse.vue?vue&type=script&lang=js"
export * from "./MenuItemCollapse.vue?vue&type=script&lang=js"
import style0 from "./MenuItemCollapse.vue?vue&type=style&index=0&id=55bd5a60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd5a60",
  null
  
)

export default component.exports